<template>
    <div class="tw:flex tw:flex-col tw:gap-4 tw:w-full">
        <div class="tw:flex tw:items-center tw:justify-between tw:gap-4">
            <div>
                <h4 class="tw:text-md tw:md:text-2xl tw:font-semibold tw:text-gray-800 tw:tracking-wide tw:mb-0">
                    {{ title }}
                </h4>
                <p
                    v-if="extraText"
                    class="tw:text-sm tw:text-gray-500 tw:mt-1"
                >
                    {{ extraText }}
                </p>
            </div>
            <div class="tw:hidden tw:md:block">
                <slot name="select">
                </slot>
            </div>
            <div class="tw:flex tw:flex-col tw:items-center tw:gap-2">
                <slot name="actions">
                    <Button
                        v-if="atras"
                        customClass="tw:flex tw:flex-row"
                        icon="fas fa-arrow-left"
                        @click="volver"
                    >
                        Atrás
                    </Button>
                </slot>
            </div>
        </div>
        <div class="tw:block tw:md:hidden">
            <slot name="select">
            </slot>
        </div>
    </div>
</template>

<script setup>
    import { useRouter } from '@/composables/common/router/useRouter'
    import Button from '@/modules/admin/ui/Button.vue'

    defineProps({
        title: {
            type: String,
            required: true
        },
        extraText: {
            type: String,
            default: null
        },
        atras: {
            type: Boolean,
            default: true
        }
    })

    const router = useRouter()

    function volver() {
        router.go(-1)
    }
</script>